export const faqs = [
  {
    num: "01",
    question:
      "Am I buying research-grade product that is actually pharmaceutical-grade quality?",
    answer:
      'We audit COAs, HPLC purity reports, and mass spec data - then cross-reference against third-party independent lab tests. "Research grade" is often cover for wildly variable quality. We benchmark what you are actually receiving and transition you to suppliers whose documentation holds up under independent scrutiny.',
  },
  {
    num: "02",
    question: "My exosome supplier charges a premium. Is that market rate?",
    answer:
      "Often not. BioChain SPY Index data shows MSC-derived exosomes from AATB-accredited suppliers with full NTA documentation clearing well below clinic-facing distributor pricing in closed transactions. Distributor markups of 2–3× over manufacturer price are common. We pull current market comps, show you what comparable buyers paid, and negotiate on your behalf.",
  },
  {
    num: "03",
    question:
      "What is the regulatory risk of sourcing peptides internationally?",
    answer:
      "We map the regulatory landscape for each compound and jurisdiction before any sourcing contract - research-use exemptions, customs classification, scheduling status, and import requirements. We structure supplier contracts with compliance representations so liability is clearly assigned.",
  },
  {
    num: "04",
    question:
      "How does RampRate get paid - and does that create a conflict of interest?",
    answer:
      "Two clean models. First: a performance fee on verified Year 1 savings only - you pay nothing if we find nothing. Second: a disclosed supplier-paid fee, visible to you in writing before any transaction closes, with a contractual requirement that the supplier offer you the same price they would offer any comparable direct buyer. No hidden rebates, no back-channel commissions.",
  },
  {
    num: "05",
    question: "Can RampRate help build verified provenance for our biologics?",
    answer:
      "Yes - we architect chain-of-custody verification for biologics: lot traceability, donor consent documentation, and audit-ready records for every transfer event, connected to ImpactSoul for organizations pursuing regenerative-capital alignment.",
  },
  {
    num: "06",
    question: "How is this different from just going direct to a supplier?",
    answer:
      "Going direct gives you one supplier’s price and one supplier’s documentation. RampRate gives you the market - what our vetted network charges, what independent labs confirm, and what comparable buyers paid recently. We also build multi-supplier architecture so a single supplier backlog does not shut down your operation, and we negotiate on your behalf.",
  },
];
